import { createContext, useContext } from 'react';
import type { SidebarPage } from '../components/appSidebar/AppSidebar';

interface NavigationContextValue {
  /** 현재 페이지. */
  page: SidebarPage;
  /** 페이지 이동 — 사이드바 밖(헤더 톱니 등)에서 페이지를 바꿀 때 쓴다. */
  go: (page: SidebarPage) => void;
}

// Provider 밖(페이지를 단독으로 렌더하는 테스트 등)에서도 안전하도록 no-op 기본값을 둔다.
const NavigationContext = createContext<NavigationContextValue>({ page: 'daily', go: () => {} });

/**
 * 앱은 React Router 없이 MainApp의 `page` state로 화면을 전환한다(AppSidebar가 그 state를
 * 바꾼다). 사이드바가 아닌 곳(상단 헤더의 설정 톱니 등)에서도 페이지를 옮길 수 있게, MainApp이
 * 이 컨텍스트로 `go`를 내려준다.
 */
export const NavigationProvider = NavigationContext.Provider;

export const useNavigation = (): NavigationContextValue => useContext(NavigationContext);
